
import "../css/Fondo.css"
import React from 'react'


const Fondo = () => {
    return (
        <>
            <div className='containerfondocomponent'>

                <p class="textoprincipal">Llevando la luz de cristo a la nueva generación</p>  
            </div>
        </>
    )
}

export default Fondo;